import React, { useState, Fragment } from "react";
import Text from 'antd/es/typography/Text';
import Row from "antd/es/row/index";
import Col from "antd/es/col/index";
import cloneDeep from "lodash.clonedeep";
import Title from 'antd/es/typography/Title';
import { normalizeText } from 'lib'

const correctAnswerStyle = {
  color: '#1C9E11',
}
const incorrectAnswerStyle = {
  color: '#DB2728',
  textDecoration: 'line-through',
}
const invalidStyle = {
  color: '#DB2728',
}
const editableFirefoxJumpingInputFix = {
  width: '10vw',
}
const top = '1em'
const left = (hanzi) => `${hanzi.length * 0.25}em`
const letters = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']

export default function SentenceComponent(props) {
  const {
    letterIndex,
    sentence,
    onSetBlank,
    checkAnswer,
    hasCorrectAnswers,
    correctAnswers,
  } = props
  const {
    hanzi,
    pinyin,
    blank,
  } = sentence
  const [valid, setValid] = useState(false)

  const validate = (value) => {
    if (!value || value.length === 0) {
      setValid(false)
    } else {
      setValid(true)
    }
  }

  const setBlank = (value, index) => {
    validate(value)
    const tempSentence = cloneDeep(sentence)
    tempSentence.blank[index] = value
    onSetBlank(tempSentence.blank)
  }

  const correctHanziNormal = correctAnswers.hanzi.reduce(normalizeText).split('/')
  const correctPinyinNormal = correctAnswers.pinyin.reduce(normalizeText).split('/')
  const correctAnswerNormal = correctHanziNormal.map((hanzi, index) => {
    let answer = hanzi+'/'+correctPinyinNormal[index]
    return (index < correctPinyinNormal.length-1) ? answer+' or ' : answer;
  }).reduce((prev, curr) => prev+curr)

  return (
    <Fragment>
      <Row type="flex" justify="center"
           style={{ textAlign: "left", alignItems: 'baseline' }}
       >
        <Col></Col>
        <Col style={{ marginRight: 12 }}>
          <Title style={{ alignSelf: 'baseline', color: '#F56626' }} level={2}>
            {letters[letterIndex]}:
          </Title>
        </Col>
        {
          hanzi.map((hanzi, index) => {
            const content = (hanzi === -1 && pinyin[index] === -1) ?
            (<Fragment>
              {
                !checkAnswer && (
                  <Text style={{ ...editableFirefoxJumpingInputFix, maxHeight: 0 }} editable={{ onChange: value => setBlank(value, index) }}>
                    {blank[index]}
                  </Text>
                )
              }
              {
                checkAnswer && (valid && hasCorrectAnswers(blank[index], index)) && (
                  <Text
                    style={{ ...editableFirefoxJumpingInputFix, maxHeight: 0, ...correctAnswerStyle }}
                    editable={{ onChange: value => setBlank(value, index) }}
                  >
                    {blank[index]}
                  </Text>
                )
              }
              {
                checkAnswer && (valid && !hasCorrectAnswers(blank[index], index)) && (
                  <Fragment>
                    <Text
                      style={{ ...editableFirefoxJumpingInputFix, maxHeight: 0, ...incorrectAnswerStyle }}
                    >
                      {blank[index]}
                    </Text>
                    <Text
                      style={{ ...editableFirefoxJumpingInputFix, maxHeight: 0, ...correctAnswerStyle }}
                    >
                      {correctAnswerNormal}
                    </Text>
                  </Fragment>
                )
              }
              {
                checkAnswer && (!valid) && (
                  <Fragment>
                    <Text
                      style={{ ...editableFirefoxJumpingInputFix, maxHeight: 0, ...invalidStyle }}
                    >
                      {correctAnswerNormal}
                    </Text>
                  </Fragment>
                )
              }
            </Fragment>) :
            (<Fragment>
              <ruby>{hanzi}<rt>{pinyin[index]}</rt></ruby>
            </Fragment>)

            return (
              <Fragment key={index}>
                <Col>
                  {content}
                </Col>
              </Fragment>
            )
          })
        }
      </Row>
    </Fragment>
  );
};